import { defineComponent as t, h as e } from "vue";
import i from "./ghl-ui.es937.js";
import o from "./ghl-ui.es938.js";
import a from "./ghl-ui.es908.js";
import d from "./ghl-ui.es983.js";
const u = t({
  name: "DataTableExpandTrigger",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    expanded: Boolean,
    loading: Boolean,
    onClick: {
      type: Function,
      required: !0
    },
    renderExpandIcon: {
      type: Function
    }
  },
  render() {
    const {
      clsPrefix: n
    } = this;
    return e("div", {
      class: [`${n}-data-table-expand-trigger`, this.expanded && `${n}-data-table-expand-trigger--expanded`],
      onClick: this.onClick,
      onMousedown: (r) => {
        r.preventDefault();
      }
    }, e(i, null, {
      default: () => this.loading ? e(o, {
        key: "loading",
        clsPrefix: this.clsPrefix,
        radius: 85,
        strokeWidth: 15,
        scale: 0.88
      }) : this.renderExpandIcon ? this.renderExpandIcon({
        expanded: this.expanded
      }) : e(a, {
        clsPrefix: n,
        key: "base-icon"
      }, {
        default: () => e(d, null)
      })
    }));
  }
});
export {
  u as default
};
